// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.skeleton[data-v-0d1f4b65] {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.el-skeleton[data-v-0d1f4b65] {\n  margin-bottom: 10px;\n}\n.page[data-v-0d1f4b65] {\n  display: flex;\n  justify-content: center;\n  margin-top: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
